export const compareCarInfoFn = info => {
  console.log(info)
  console.log(info.find(item => item.status === 1))
  let oldInfo = info.find(item => item.status === 2).carInfo
  let newInfo = info.find(item => item.status === 1).carInfo
  let { plate: OPlate, fin: OFin, vin: OVin, threeGuaranteesDate: OThreeGuaranteesDate } = oldInfo
  let { plate: NPlate, fin: NFin, vin: NVin, threeGuaranteesDate: NThreeGuaranteesDate } = newInfo
  console.log(OVin === NVin, OVin, NVin)
  let compareCarInfo = [
    {
      title: '已认证车辆信息',
      info: {
        plate: OPlate,
        fin: OFin,
        vin: OVin,
        threeGuaranteesDate: OThreeGuaranteesDate,
        finDiff: OFin !== NFin,
        plateDiff: OPlate !== NPlate,
        vinDiff: OVin !== NVin,
        dateDiff: OThreeGuaranteesDate !== NThreeGuaranteesDate
      }
    },
    {
      title: '新建车辆信息',
      info: {
        plate: NPlate,
        fin: NFin,
        vin: NVin,
        threeGuaranteesDate: NThreeGuaranteesDate,
        finDiff: OFin !== NFin,
        plateDiff: OPlate !== NPlate,
        vinDiff: OVin !== NVin,
        dateDiff: OThreeGuaranteesDate !== NThreeGuaranteesDate
      }
    }
  ]
  return compareCarInfo
}

// export const info = [
//   {
//     status: 2,
//     carInfo: {
//       baumuster: '118347',
//       carAge: null,
//       contactGender: null,
//       contactMobile: null,
//       contactName: null,
//       createTime: '2021-04-29 07:35:16',
//       customerId: '114884',
//       defaultFlag: 0,
//       fin: '',
//       firstCertInfo: null,
//       id: '168',
//       model: 'CLA 250 4MATIC 轿跑车 / CLA 260 4MATIC 轿跑车',
//       nickName: null,
//       plate: '',
//       remark: null,
//       series: null,
//       statusFlag: 1,
//       threeGuaranteesDate: null,
//       updateTime: '2021-04-29 07:35:16',
//       vin: '235688964235789966'
//     }
//   },
//   {
//     status: 1,
//     carInfo: {
//       baumuster: '118347',
//       carAge: null,
//       contactGender: null,
//       contactMobile: null,
//       contactName: null,
//       createTime: '2021-04-29 07:35:16',
//       customerId: '114884',
//       defaultFlag: 0,
//       fin: '',
//       firstCertInfo: null,
//       id: '168',
//       model: 'CLA 250 4MATIC 轿跑车 / CLA 260 4MATIC 轿跑车',
//       nickName: null,
//       plate: '',
//       remark: null,
//       series: null,
//       statusFlag: 1,
//       threeGuaranteesDate: null,
//       updateTime: '2021-04-29 07:35:16',
//       vin: '235688964235789966'
//     }
//   }
// ]
